/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

import HttpClient from './HttpClient';

class SettingsHttpClient {
  static retrieve() {
    const method = 'GET';

    const url = 'settings';

    return HttpClient.request(method, url);
  }

  static update(settings) {
    const method = 'PUT';

    const url = 'settings';

    return HttpClient.request(method, url, settings);
  }
}

export default SettingsHttpClient;
